import styled from 'styled-components';

export const Styling = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 width: 60%;
 margin: 1% auto 3%;
 border-radius: 20px;
 border: 3px solid #000;
 background-color: #fff;
`;

export const Switch = styled.div`
 display: flex;
 justify-content: center;
 align-items: center;

 button {
  background-color: #006798;
  border-radius: 10px;
  padding: 20% 50%;
 }

 span {
 }
`;

export const Submission = styled.div`
 display: flex;
 align-items: center;
 border: 3px solid #006798;
 border-radius: 16px;
 margin: 2% 0;
 padding: 1% 3%;
 font-size: 1.1rem;
 cursor: pointer;

 & + & {
  margin-top: 0;
 }

 div {
  flex: 1;
 }

 span {
  color: #777;
  padding: 0.5% 1%;
  border: 3px solid #f00;
  border-radius: 8px;
 }
`;
